<template> </template>

<script>
export default {
	name: 'BaseSlide',
	props: {
		slide: Object,
	},
	methods: {
		subcommand(name, data) {
			console.log('subcommand');
			this.$emit('subcommand', name, data);
		},
	},
};
</script>

<style scoped></style>
